import React, { Component } from "react";
import Navbar from "./global-components/navbar";
import PageHeader from "./global-components/page-header";
import Shop from "./shop-components/shop-right-sidebar";
import CallToActionV1 from "./section-components/call-to-action-v1";
import Footer from "./global-components/footer";
import { withAppData } from "../app/withAppData";
import { API_FILE_URL } from "../api/config";
import { withRouter } from "react-router-dom";

class Shop_V1 extends Component {
  render() {
    const categoryId = this.props.location?.state?.categoryId || null;
    const { product, category, loading, lang, settings, pageConfig } = this.props.appData;
    const productConfig =
      pageConfig?.product?.settings?.translations?.[lang] || {};
    const productImg = pageConfig?.product?.settings?.breadcrumb;
    // null-safe dizi
    const categories = Array.isArray(category?.categories)
      ? category.categories
      : [];
      let publicUrl = process.env.PUBLIC_URL + "/";
    return (
      <div>
        <Navbar />
        <PageHeader
          lang={lang}
          Img={productImg}
          headertitle={productConfig.productsTitle || "Ürünler"}
          subheader={productConfig.productsTitle || "Ürünler"}
        />
        <Shop
          lang={lang}
          icon={settings?.logo ? API_FILE_URL + settings?.logo : publicUrl + "assets/img/blog/author.jpg"}
          product={product}
          loading={loading}
          categories={categories}
          selectedCategoryFromLink={categoryId}
        />
        <CallToActionV1 />
        <Footer />
      </div>
    );
  }
}
export default withAppData(withRouter(Shop_V1));

